import React, {ComponentProps} from 'react';
import Icon from 'carbon-react/lib/components/icon';

import {colors} from './style';

export function NoOperationalDataIcon(props: Omit<ComponentProps<typeof Icon>, 'type'>) {
    return <Icon type="warning" color={colors.warning} {...props} />;
}
